<div *ngIf="loading" class="loading">
  <mat-spinner></mat-spinner>
</div>
<div class="all-data">
  <div class="table">
    <mat-progress-bar mode="indeterminate" *ngIf="dataSource.loading$ | async"></mat-progress-bar>
    <table
      [dataSource]="dataSource"
      (matSortChange)="sortData()"
      mat-table
      class="table__container"
      matSort
      matSortDisableClear
    >
      <ng-container *ngFor="let column of tableColumns;" matColumnDef="{{column.columnDef}}">
        <th mat-header-cell *matHeaderCellDef
            class="table__cell-title"
            [ngClass]="{'table__cell-highlight': isFilterEmpty(column.columnDef)}"
            [mat-sort-header]="column.sortDef??column.columnDef"
            [disabled]="columnsWithoutSort.includes(column.columnDef)">
          {{ column.header }}
          @if (column.filterType) {
            <app-all-data-filter-dialog-button
              [data]="getFilter(column.columnDef)"
              [header]="column.header"
              [headerRef]="header"
              [filterType]="column.filterType"
              [options]="column.options"
              [isSingle]="column.isSingle"
              (save)="column.save?.($event)"
            />
          }
          <div #header class="all-data__cell-reservation"></div>
        </th>
        <td mat-cell *matCellDef="let element" class="table__cell">
          {{ column.cell(element) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          [ngClass]="{'highlighted-row': row.isDuplicated}"></tr>
    </table>
  </div>
  <mat-paginator
    #paginator
    [pageSize]='15'
    [pageSizeOptions]="[15,20, 50]"
    showFirstLastButtons
  ></mat-paginator>
</div>
